import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { CostumeSizing } from '../model/costume-sizing';

export const getCostumeSizingsAPI = async (
  recitalId: string,
  performanceId?: string,
) => {
  const params = new URLSearchParams();
  if (performanceId) {
    params.append('performanceId', performanceId);
  }

  const response = await baseAPI.get<CostumeSizing[]>(
    `/recitals/${recitalId}/sizing${params.toString() ? `?${params.toString()}` : ''}`,
  );
  return response.data;
};

export const getCostumeSizingsOptions = (
  recitalId: string,
  performanceId?: string,
) => {
  return queryOptions({
    queryKey: [KEYS.RECITALS, recitalId, KEYS.SIZING, performanceId],
    queryFn: () => getCostumeSizingsAPI(recitalId, performanceId),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useGetCostumeSizings = (
  recitalId: string,
  performanceId?: string,
) => {
  return useQuery(getCostumeSizingsOptions(recitalId, performanceId));
};
